import { useDetermineMobile } from '@myrealtrip/device-detect';

import styled from '@emotion/styled';
import { globalVariables } from '../../../shared/designSystem/constants';

import AppStoreList from './AppStoreList';
import SNSList from './SNSList';

export default function OutLinkContainer() {
  const isMobile = useDetermineMobile();

  const Container = isMobile ? MobileContainer : DesktopContainer;

  return (
    <Container>
      <SNSList />
      {!isMobile && <Divider />}
      <AppStoreList />
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: flex-end;
`;

const MobileContainer = styled(CommonContainer)`
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  order: 2;
`;

const DesktopContainer = CommonContainer;

const Divider = styled.span`
  width: 1px;
  height: 20px;
  background-color: ${globalVariables.gray_300};
  margin: 0 10px;
`;
